import { get, orderBy } from 'lodash'

export const moveItemInArray = (arr: any[], fromIndex: number, toIndex: number): any[] => {
  const element = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, element)
  return arr
}

/**
 * Normalizes a string by removing accents and converting to lowercase
 * Example: "Éléphant" => "elephant"
 * @param str - The string to normalize
 * @returns The normalized string
 */
const normalizeString = (str: string): string => {
  return str
    .normalize('NFD') // Decompose characters (é => e + ́)
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .toLowerCase()
}

/**
 * Sorts an array ignoring case and accents
 * Characters like "é" are treated as "e" for sorting purposes
 * @param array - The array to sort
 * @param key - The key to sort by
 * @returns A new sorted array
 */
export const sortByIgnoreCase = <T>(array: T[], key: keyof T): T[] =>
  orderBy(array, [item => normalizeString((get(item || {}, key) as string) || '')])

/**
 * Removes duplicate objects from an array based on a specific key
 * @param array - The array to deduplicate
 * @param key - The key to use for comparison (must be a key of T)
 * @returns A new array with duplicates removed, keeping the first occurrence
 */
export const deduplicateByKey = <T>(array: T[], key: keyof T): T[] => {
  return array.filter((item, index, self) => index === self.findIndex(i => i[key] === item[key]))
}
